<template>
  <div class="container-table-striped w-100 mt-4">
    <div class="table-hover">
      <table class="table content-table-striped table-h">
        <thead>
          <tr class="row global-thead-dark thead-property">
            <th class="col-3 text-left bold">
              Nombre
            </th>
            <th class="col-3 text-left bold">
              Documento
            </th>
            <th class="col-3 text-left bold">
              Categoría
            </th>
          </tr>
        </thead>
        <tbody v-if="rows.length > 0 || addedFiles.length > 0 || true">
          <tr v-for="row in rows" :key="row.id" class="row">
            <td class="col-md-3 text-left">
              <b class="ml-3">
                <span>{{ row.documentTitle }}</span>
              </b>
            </td>
            <td class="col-md-3 text-left">
              <div class="ml-3">
                <span>{{ row.fileName }}</span>
              </div>
            </td>
            <td class="col-md-3 text-left">
              <div class="ml-3">
                <span>{{ row.documentCategoryDescription }}</span>
              </div>
            </td>
            <td class="col-md-3 text-right">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu dropdown-menu-right pb-0">
                <a
                  class="drop-item cursor-pointer"
                  @click="downloadDocuments(row)"
                >
                  <em class="fas fa-file-search text-green pr-2" />
                  <span>Ver Documento</span>
                </a>
                <a
                  v-if="canDeleteDocumentCategory(row.documentCategoryId)"
                  class="drop-item cursor-pointer"
                  @click="deleteDocument(row.documentId)"
                >
                  <em class="fa fa-trash text-red pr-2" />
                  <span>Eliminar</span>
                </a>
              </div>
            </td>
          </tr>
          <!--ECG:Archivos añadidos pero no guardados todavia -->
          <tr v-for="(row, i) in addedFiles" :key="i" class="row">
            <td class="col-md-3 text-left">
              <b class="ml-3">
                <span>{{ row.name }}</span>
              </b>
            </td>
            <td class="col-md-3 text-left">
              <div class="ml-3">
                <span>{{ row.document.name }}</span>
              </div>
            </td>
            <td class="col-md-3 text-left">
              <div class="ml-3">
                <span>{{ row.category.name }}</span>
              </div>
            </td>
            <td class="col-md-3 text-right">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu dropdown-menu-right pb-0">
                <a class="drop-item cursor-pointer" @click="viewUnsavedDoc(i)">
                  <i class="fas fa-file-search text-green pr-2" />
                  <span>Ver Documento</span>
                </a>
                <a
                  v-if="canDeleteDocumentCategory(row.documentCategoryId)"
                  class="drop-item cursor-pointer"
                  @click="deleteDocument(row.documentId)"
                >
                  <i class="fas fa-trash text-green pr-2" />
                  <span>Eliminar</span>
                </a>
              </div>
            </td>
          </tr>
          <!--Resumen de logros y resultados -->
          <tr v-if="hasResultSummary" class="row">
            <td class="col-md-3 text-left">
              <b class="ml-3">
                <span>Resumen de resultados</span>
              </b>
            </td>
            <td class="col-md-3 text-left">
              <div class="ml-3">
                <span>-</span>
              </div>
            </td>
            <td class="col-md-3 text-left">
              <div class="ml-3">
                <span>-</span>
              </div>
            </td>
            <td class="col-md-3 text-right">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu dropdown-menu-right pb-0">
                <a
                  class="drop-item cursor-pointer"
                  @click="downloadSummary(reportTypes.resultSummary)"
                >
                  <i class="fas fa-file-search text-green pr-2" />
                  <span>Ver Documento</span>
                </a>
              </div>
            </td>
          </tr>
          <tr v-if="hasAchievementSummary" class="row">
            <td class="col-md-3 text-left">
              <b class="ml-3">
                <span>Resumen de logros</span>
              </b>
            </td>
            <td class="col-md-3 text-left">
              <div class="ml-3">
                <span>-</span>
              </div>
            </td>
            <td class="col-md-3 text-left">
              <div class="ml-3">
                <span>-</span>
              </div>
            </td>
            <td class="col-md-3 text-right">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu dropdown-menu-right pb-0">
                <a
                  class="drop-item cursor-pointer"
                  @click="downloadSummary(reportTypes.achievementSummary)"
                >
                  <i class="fas fa-file-search text-green pr-2" />
                  <span>Ver Documento</span>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr v-if="!isAddMode">
            <td colspan="3">
              <div v-if="!disabledAll" class="text-center">
                <BoxIconButton
                  v-if="IsDraft"
                  :icon="'fas fa-file-plus'"
                  :title="'Presione aquí para anejar documento'"
                  class="w-100"
                  :disabled="disabledAll"
                  @click="onAddClickHandler"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <ServiceDocumentAdd
                v-if="isAddMode"
                accept=".pdf"
                :immediate-save="!!studentServiceId"
                :student-service-id="studentServiceId"
                @on-add="onAddFileHandler"
                @on-cancel="onCancelAddFileHandler"
              />
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BoxIconButton } from '@/components/pei/shared';
import ServiceDocumentAdd from './ServiceDocumentAdd';
import store from '@/store/index'; //Se debe coordinar si los components tendran acceso al store o no.
import peiStatus from '@/utils/constants/pei/peiStatus';
import general from '@/services/pei/general';
import thrpyReferralService from '@/services/pei/thrpyReferrals';
import alert from '@/mixin/alert.mixin';
import codeDocumentTypes from '@/utils/constants/documentTypes';
import generalService from '@/services/pei/general';
import resultSummaryReportTypes from '@/utils/constants/pei/resultSummaryReportTypes';

export default {
  name: 'ServiceDocument',
  mixins: [alert],
  data() {
    return {
      rows: [],
      isAddMode: false,
      selectedPeiStatus: store.getters.SelectedPeiStatus,
      peiStatus: peiStatus,
      addedFiles: [],
      documentCategories: [
        {
          id: 75,
          name: 'Evaluación',
        },
        {
          id: 76,
          name: 'Minuta',
        },
      ],
    };
  },
  props: {
    disabledAll: {
      type: Boolean,
      default: () => false,
    },
    isTherapy: {
      type: Boolean,
      default: () => false,
    },
    studentServiceId: {
      type: Number,
      default: null,
    },
    analysisServiceId: {
      type: Number,
      default: null,
    },
    hasResultSummary: {
      type: Boolean,
      default: false,
    },
    hasAchievementSummary: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      peiId: 'SelectedPei',
    }),
    IsDraft: function() {
      return this.selectedPeiStatus == peiStatus.Borrador;
    },
    reportTypes() {
      return resultSummaryReportTypes;
    },
  },
  methods: {
    async downloadSummary(reportType) {
      let report = `referral/downloadresultsummariesbytype/${this.analysisServiceId}/${reportType}`;
      await general.downloadReport(report);
      return;
    },
    async downloadDocuments(item) {
      if (
        item.documentCategoryId == codeDocumentTypes.IntitialEvaluation ||
        item.documentCategoryId == codeDocumentTypes.AdditionalEvaluation
      ) {
        await generalService.downloadDocumentByAttachmentId(item.documentId);
        return;
      }

      if (item.referralItemAttachmentId) {
        return this.$ApiGet(
          `/api/documents/downloadtherapyreferral/${item.referralItemAttachmentId}`
        )
          .then((response) => {
            if (response.status == 200) {
              general.downloadDocument(response.data);
            }
          })
          .catch((e) => {
            return e;
          });
      }
    },
    canDeleteDocumentCategory(category) {
      return this.documentCategories.some((x) => x.id === category);
    },
    async deleteDocument(referralItemAttachmentId) {
      thrpyReferralService
        .deleteThrpyReferralItemAttachment(referralItemAttachmentId)
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'El documento ha sido eliminado exitosamente.',
            'success'
          );

          this.getDocuments();
        })
        .catch((error) => {
          if (error && error.response && error.response.data) {
            this.ShowToast('', error.response.data.message, 'error');
          }
        });
    },
    viewUnsavedDoc(addedFileIndex) {
      general.documentDownloadLocalFile(
        this.addedFiles[addedFileIndex].document
      );
    },
    async getDocuments() {
      let self = this;
      let result;

      if (this.isTherapy) {
        result = await general
          .getReferralDocuments(this.analysisServiceId)
          .catch((err) => {
            self.response = err;
          });
      } else {
        result = await general
          .getReferralDocumentsByStudentServiceId(
            this.studentServiceId,
            this.peiId
          )
          .catch((err) => {
            self.response = err;
          });
      }

      this.rows = result.data.filter(
        (doc) => doc.documentTitle !== null && doc.documentId !== null
      );
    },
    onAddClickHandler() {
      this.isAddMode = true;
      this.$emit('on-add');
    },
    onAddFileHandler(i) {
      if (this.studentServiceId) {
        this.getDocuments();
      } else {
        this.addedFiles.push(i);
      }

      this.isAddMode = false;
    },
    onCancelAddFileHandler() {
      this.isAddMode = false;
    },
    getAddedFiles() {
      return this.addedFiles;
    },
    clearAddedFiles() {
      this.addedFiles = [];
    },
  },
  components: {
    BoxIconButton,
    ServiceDocumentAdd,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
</style>
